class SwitchBox {
  constructor({ x = 0, y = 0 }) {
    this.x = x;
    this.y = y;
    this.z = 3;

    this.spriteName = 'switchBox';

    this.frameHeight = 5;
    this.frameWidth = 6;
    this.framePadX = 1;

    this.width = this.frameWidth * 3;
    this.height = this.frameHeight * 3.5;

    this.frame = 0;
  }

  update() {

  }

  render(canvas) {
    canvas.drawThing(this, this.frame, 0, this.framePadX);
  }
}

export default SwitchBox;
